var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"magnifier col-12 text-center no-padding"},[_c('img',{ref:"activeProductImage",staticClass:"main-product-image",attrs:{"src":_vm.src,"data-zoom-image":_vm.src,"id":"active-product-image","alt":_vm.alt}})])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b5d608d0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Resources/assets/js/UI/components/image-magnifier.vue
// module id = AVcQ
// module chunks = 0